import { uploadComplete } from '../actions/upload';
import { getType } from 'typesafe-actions';
var initialState = {
  userPaperCount: 0
};
var tagmanager = function tagmanager() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case getType(uploadComplete):
      {
        return Object.assign({}, state, {
          userPaperCount: state.userPaperCount + 1
        });
      }
    default:
      return state;
  }
};
export default tagmanager;